import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import React from "react";

// import Grid from '@material-ui/core/Grid'
// import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 4,
    height: 33,
    width: 63,
  },
  left_btn: {
    backgroundColor: theme.palette.background.paper,
    height: 33,
    width: 33,
    marginRight: theme.spacing(0.5),
    minWidth: 0,
  },
  right_btn: {
    backgroundColor: theme.palette.background.paper,
    height: 33,
    width: 33,
    marginLeft: theme.spacing(0.5),
    minWidth: 0,
  },
  input: {
    textAlign: "center",
  },
}));

function QuantityButton({
  value = 0,
  onChange = () => {},
  minValue = 0,
  className,
}) {
  const classes = useStyles();

  const handleChange = (e) => {
    if (e.target.value <= minValue) {
      onChange(minValue);
    } else {
      onChange(parseInt(e.target.value, 10) || 0);
    }
  };

  const add1 = () => {
    onChange(value + 1);
  };

  const subtract1 = () => {
    if (value <= minValue) {
      onChange(minValue);
    } else {
      onChange(value - 1);
    }
  };

  return (
    <Box display="flex" className={className}>
      <Button className={classes.left_btn} onClick={subtract1}>
        <Icon>remove</Icon>
      </Button>
      <Paper elevation={0} className={classes.paper}>
        <InputBase
          value={value}
          onChange={handleChange}
          inputProps={{ className: classes.input }}
        />
      </Paper>
      <Button className={classes.right_btn} onClick={add1}>
        <Icon>add</Icon>
      </Button>
    </Box>
  );
}

QuantityButton.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  minValue: PropTypes.number,
  className: PropTypes.string,
};

export default QuantityButton;
